/*
 *
 * OperationDetailModal
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 06-Dec-2024
 */

import OperationDetailModal from './OperationDetailModalContainer'

export default OperationDetailModal
